import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCheck24 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m18.737 7.676-7.987 8.713-5.4-4.63 1.3-1.518 3.933 3.37 6.68-7.287z",
		clipRule: "evenodd"
	})
});
const ForwardRef = forwardRef(SvgIconCheck24);
export default ForwardRef;
